import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  apiKeyRow: {
    alignItems: 'flex-start',
    display: 'flex',
    gap: theme.new.spacing.medium,
  },
  apiKeyField: {
    flex: 1,
  },
  verifiedRow: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.new.spacing.xsmall,
    alignSelf: 'stretch',
  },
  verifiedText: {
    color: theme.new.color.success[600],
  },
  checkIcon: {
    height: '20px',
    width: '20px',
  },
  checkbox: {
    '&.Mui-checked .MuiSvgIcon-root': {
      fill: theme.new.color.brandPrimary,
    },
  },
  termsLink: {
    color: theme.new.color.brandPrimary,
  },
  helperText: {
    color: theme.new.color.textSecondary,
  },
}));

export default useStyles;
